import ProjectColorsPalette from "./project-palette"

// copy from $gd-core-colors
const paletteString = '$palette-project-11, // 1\n' +
    '$palette-project-7, $palette-project-7, $palette-project-8, // 2 3 4\n' +
    '$palette-project-9, $palette-project-9, $palette-project-0, // 5 6 7\n' +
    '$palette-project-0, $palette-project-0, $palette-project-2, // 8 9 10\n' +
    '$palette-project-3, $palette-project-3, $palette-project-3, // 11 12 13\n' +
    '$palette-project-2, $palette-project-4, $palette-project-5, // 14 15 16\n' +
    '$palette-project-6, $palette-project-11, $palette-project-11, // 17 18 19\n' +
    '$palette-project-10, $palette-project-1, $palette-project-1, // 20 21 22\n' +
    '$palette-project-9, $palette-project-11, $palette-project-9, // 23 24 25\n' +
    '$palette-project-11, $palette-project-7; // 26 27'

// get all colors numbers from palette in correct order
const regexp = new RegExp(/(\$palette-project-)(.+?)[,|;]/, 'gmis')
const matches = [...paletteString.matchAll(regexp)]

// fill CoreColors with hex colors according to palette colors numbers
const CoreColors: string[] = []
_.map(matches, (match: any)=>{
    CoreColors.push(ProjectColorsPalette[match['2']])
})

export default CoreColors